export default __webpack_public_path__ + "static/media/19.37148cc3.jpg";